import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, FormLabel } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from "@material-ui/core/MenuItem";
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import React, { useEffect, useState } from 'react';
import {useForm} from "react-hook-form";
import TipoPerfil from '../../../constants/tipoPerfil';
import { convidar } from '../../../services/convite/ConviteService';
import ConviteSucesso from '../sucesso';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {recuperarAtuacoes} from "../../../services/usuario/UsuarioService";

const ConviteUsuario = (props) => {

  const { open, onClose } = props;
  const [openSucesso, setOpenSucesso] = useState(false);
  const { register, handleSubmit, errors, setValue, getValues, clearError } = useForm();
  const [atuacoes, setAtuacoes] = useState([]);


  const initialState = {
    nome: '',
    sobrenome: '',
    emailInstitucional: '',
    tipoPerfil: '',
    idAtuacao: 1,
  }

  useEffect(() => {
    register({ name: 'nome' }, { required: 'Nome é obrigatório' });
    register({ name: 'sobrenome' }, { required: 'Sobrenome é obrigatório' });
    register({ name: 'emailInstitucional' }, { required: 'E-mail institucional é obrigatório' });
    register({ name: 'tipoPerfil' }, { required: 'Tipo de Perfil é obrigatório' });

    recuperarAtuacoes().then(response => {
      setAtuacoes(response?.data || []);
    });
  }, [])

  const [form, setForm] = useState(initialState);
  const handleChange = (event) => {
    const { name, value } = event.target
    setValue(name, value);
    clearError(name);
    setForm({ ...form, [name]: value })
  };


  const submit = async () => {
    onClose();
    const response = await convidar(form);

    if (response && response.status === 200) {
      setOpenSucesso(true)
    }
  }

  return (
    <div>
      <Dialog open={open} onClose={onClose}>
        <form onSubmit={handleSubmit(submit)}>
          <DialogTitle>Convidar Usuário</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="nome"
                  InputLabelProps={{ shrink: true }}
                  value={form.nome}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  error={!!errors.nome}
                  helperText={errors.nome && errors.nome.message}
                  label="Nome" />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="sobrenome"
                  InputLabelProps={{ shrink: true }}
                  value={form.sobrenome}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  error={!!errors.sobrenome}
                  helperText={errors.sobrenome && errors.sobrenome.message}
                  label="Sobrenome" />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="emailInstitucional"
                  InputLabelProps={{ shrink: true }}
                  value={form.emailInstitucional}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  error={!!errors.emailInstitucional}
                  helperText={errors.emailInstitucional && errors.emailInstitucional.message}
                  label="E-mail institucional" />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth error={!!errors.tipoPerfil}>
                  <FormLabel shrink="true">Tipo de Perfil </FormLabel>
                  <Select
                    id="tipoPerfil"
                    name="tipoPerfil"
                    value={form.tipoPerfil}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined">
                    <MenuItem value={TipoPerfil.CONSELHEIRO.id}>Conselheiro</MenuItem>
                    <MenuItem value={TipoPerfil.EQUIPE_TECNICA.id}>Equipe Técnica</MenuItem>
                    <MenuItem value={TipoPerfil.INTERLOCUTOR.id}>Interlocutor</MenuItem>
                  </Select>
                  <FormHelperText>{errors.tipoPerfil && errors.tipoPerfil.message}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <InputLabel shrink>Atuação</InputLabel>
                <Select
                  required
                  id="idAtuacao"
                  name="idAtuacao"
                  value={form.idAtuacao}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  IconComponent={ExpandMoreIcon}
                  inputProps={{
                    margin: 'normal'
                  }}>
                  {atuacoes.map((uf, key) => (
                    <MenuItem key={key} value={uf.id}>{uf.descricao}</MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="outlined"
              onClick={onClose}>
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained">
              Convidar Usuário
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <ConviteSucesso open={openSucesso} onClose={() => setOpenSucesso(false)} />
    </div>
  );
}


export default ConviteUsuario;
